module.exports = __webpack_public_path__ + "img/expert.13899c6.svg";